import {css, defineCssVars, defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';

const vars = defineCssVars(`skeleton`, [`start-color`, `end-color`]);

export const skeletonCSS = css({
  [vars[`start-color`].variable]: `colors.obsidian.100`,
  [vars[`end-color`].variable]: `colors.obsidian.400`,
  _dark: {
    [vars[`start-color`].variable]: `colors.obsidian.800`,
    [vars[`end-color`].variable]: `colors.obsidian.600`,
  },
});
const baseStyle = defineStyle(props => ({
  ...skeletonCSS(props),
  background: vars[`start-color`].reference,
  borderColor: vars[`end-color`].reference,
  opacity: 0.7,
  borderRadius: `sm`,
}));

export const skeletonTheme = defineStyleConfig({
  baseStyle,
});
export {vars as skeletonVars};
